import { memo, useMemo } from 'react';

import { useAppSelector } from '~/store';
import { clanHeaderLadderVMSelector } from '~/store/selectors/clanSelectors';

import ClanLeagueSign from '~/UIKit/ClanLeagueSign/ClanLeagueSign';

import type { ClanLeagueSignProps } from '~/UIKit/ClanLeagueSign/ClanLeagueSign';

interface ClanHeaderLeagueSignProps {
  clanId: number;
  isOwnClanBase: boolean;
}

const ClanHeaderLeagueSign = ({ clanId, isOwnClanBase }: ClanHeaderLeagueSignProps) => {
  const { lastRegularSeasonData, seasonTeams, hideLeagueIcon } = useAppSelector((state) =>
    clanHeaderLadderVMSelector(state, clanId),
  );

  const clanLeagueSignProps = useMemo<ClanLeagueSignProps | null>(() => {
    if (hideLeagueIcon) {
      return null;
    }

    if (!lastRegularSeasonData) {
      return null;
    }

    const league = lastRegularSeasonData.league ?? 0;
    if (typeof league !== 'number') {
      return null;
    }

    if (isOwnClanBase) {
      return {
        teamsRating: seasonTeams,
        isFullSize: false,
        clanDivision: lastRegularSeasonData.division,
        clanDivisionRating: lastRegularSeasonData.division_rating,
        clanLeague: lastRegularSeasonData.league,
        clanMaxDivisionRating: lastRegularSeasonData.division_rating_max,
        clanStage: lastRegularSeasonData.stage,
        leadingTeamNumber: lastRegularSeasonData.team_number,
      };
    }

    return {
      clanDivision: lastRegularSeasonData.division,
      clanDivisionRating: lastRegularSeasonData.division_rating,
      clanLeague: lastRegularSeasonData.league,
      clanMaxDivisionRating: lastRegularSeasonData.division_rating_max,
      clanStage: lastRegularSeasonData.stage,
    };
  }, [hideLeagueIcon, lastRegularSeasonData, isOwnClanBase, seasonTeams]);

  if (!clanLeagueSignProps) {
    return null;
  }

  return <ClanLeagueSign {...clanLeagueSignProps} />;
};

export default memo(ClanHeaderLeagueSign);
